import { render } from "./CommonButton.vue?vue&type=template&id=e5985da6&scoped=true"
import script from "./CommonButton.vue?vue&type=script&lang=js"
export * from "./CommonButton.vue?vue&type=script&lang=js"

import "./CommonButton.vue?vue&type=style&index=0&id=e5985da6&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5985da6"]])

export default __exports__